import { createSlice } from '@reduxjs/toolkit';
import { fetchAccessoriesDataAsync } from './thunk';

export const initialState = {
  result: {},
  accessoriesList: [],
  status: 'idle',
  apiFailed: false,
};

export const accessoriesSlice = createSlice({
  name: 'accessories',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchAccessoriesDataAsync.pending, (state) => {
        state.accessoriesList = [];
        state.status = 'loading';
      })
      .addCase(fetchAccessoriesDataAsync.fulfilled, (state, { payload }) => {
        state.status = 'idle';
        if (payload) {
          state.result = payload.result ?? {};
          state.accessoriesList = payload.result.listings ?? [];
        }
      })
      .addCase(fetchAccessoriesDataAsync.rejected, (state) => {
        state.status = 'idle';
        state.apiFailed = true;
      });
  },
});

export { fetchAccessoriesDataAsync };
export default accessoriesSlice.reducer;